import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingGroup} from './group/pricing-group';
import {PricingGrade} from './pricing-grade';

@JsonObject('model.PricingArea')
export class PricingArea extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(Number, 'deliveryBasePrice')
  deliveryBasePrice?: number

  @JsonProperty([PricingGroup], 'groups')
  groups?: PricingGroup[]

  @JsonProperty(String, 'jsonData')
  jsonData?: string;

  parsedData?: any;

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(PricingGrade, 'boxGrade')
  boxGrade?: PricingGrade

  @JsonProperty(PricingGrade, 'materialGrade')
  materialGrade?: PricingGrade;

  @JsonProperty(Number, 'avgPricePerCabinet')
  avgPricePerCabinet?: number

  @JsonProperty(Number, 'cabinetryTotal')
  cabinetryTotal?: number

  @JsonProperty(Number, 'subtotal')
  subtotal?: number

  @JsonProperty(Number, 'subtotalDelivery')
  subtotalDelivery?: number

  @JsonProperty(Number, 'subtotalDiscount1')
  subtotalDiscount1?: number

  @JsonProperty(Number, 'subtotalDiscount2')
  subtotalDiscount2?: number

  @JsonProperty(Number, 'subtotalDiscountPrice1')
  subtotalDiscountPrice1?: number

  @JsonProperty(Number, 'subtotalDiscountPrice2')
  subtotalDiscountPrice2?: number

  @JsonProperty(Number, 'subtotalInstall')
  subtotalInstall?: number

  @JsonProperty(Number, 'totalSQFTFaces')
  totalSQFTFaces?: number

  @JsonProperty(String, 'lastInteractionTime')
  lastInteractionTime?: string;
}

